import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type FolderCheckProps = IconComponentBaseProps;

export const FolderCheck = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: FolderCheckProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_4363_29549"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="25"
      >
        <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4363_29549)">
        <path
          d="M10.85 14.5963L9.252 13.0078C9.10317 12.8591 8.92908 12.7831 8.72975 12.7798C8.53042 12.7766 8.35317 12.8526 8.198 13.0078C8.04933 13.1564 7.975 13.333 7.975 13.5375C7.975 13.742 8.04933 13.9186 8.198 14.0673L10.1923 16.0865C10.3731 16.2673 10.5882 16.3577 10.8375 16.3577C11.0868 16.3577 11.3019 16.2673 11.4827 16.0865L15.6173 11.9423C15.7659 11.7936 15.8403 11.617 15.8403 11.4125C15.8403 11.208 15.7659 11.0314 15.6173 10.8828C15.4686 10.7341 15.292 10.6598 15.0875 10.6598C14.883 10.6598 14.7064 10.7341 14.5577 10.8828L10.85 14.5963ZM4.30775 20C3.80258 20 3.375 19.825 3.025 19.475C2.675 19.125 2.5 18.6974 2.5 18.1923V6.80775C2.5 6.30258 2.675 5.875 3.025 5.525C3.375 5.175 3.80258 5 4.30775 5H9.05C9.291 5 9.52275 5.04683 9.74525 5.1405C9.96758 5.234 10.1608 5.36283 10.325 5.527L11.798 7H19.6923C20.1974 7 20.625 7.175 20.975 7.525C21.325 7.875 21.5 8.30258 21.5 8.80775V18.1923C21.5 18.6974 21.325 19.125 20.975 19.475C20.625 19.825 20.1974 20 19.6923 20H4.30775ZM4.30775 18.5H19.6923C19.7821 18.5 19.8558 18.4712 19.9135 18.4135C19.9712 18.3558 20 18.2821 20 18.1923V8.80775C20 8.71792 19.9712 8.64417 19.9135 8.5865C19.8558 8.52883 19.7821 8.5 19.6923 8.5H11.1845L9.27125 6.5865C9.23908 6.5545 9.20542 6.53208 9.17025 6.51925C9.13492 6.50642 9.098 6.5 9.0595 6.5H4.30775C4.21792 6.5 4.14417 6.52883 4.0865 6.5865C4.02883 6.64417 4 6.71792 4 6.80775V18.1923C4 18.2821 4.02883 18.3558 4.0865 18.4135C4.14417 18.4712 4.21792 18.5 4.30775 18.5Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
